// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsCoreLoan,
  IsExpressLoan,
  IsExpressPlusLoan,
  IsIndustryPGLoan,
  IsPayingMortgage,
} from '../rules';

class MortgageStatementRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isExpressPlus = IsExpressPlusLoan.evaluate(data);
    const isExpress = IsExpressLoan.evaluate(data);
    const isCore = IsCoreLoan.evaluate(data);
    const isIndustryPG = IsIndustryPGLoan.evaluate(data);
    const isPayingMortgage = IsPayingMortgage.evaluate(data);

    const isRequired = (isExpressPlus || isExpress) && isPayingMortgage;
    const isOptional = (isCore || isIndustryPG) && isPayingMortgage;

    return isRequired
      ? RulesetResult.REQUIRED
      : isOptional
      ? RulesetResult.OPTIONAL
      : RulesetResult.HIDDEN;
  };
}

export default new MortgageStatementRuleset();
